/**
 * Fixed device id for all users and browsers. Sent as the DeviceId header on API requests.
 * Update this string if your backend expects a specific value.
 */
export const FIXED_DEVICE_ID = 'raslan-web-client';

export const getDeviceId = (): string => FIXED_DEVICE_ID;
